import { cva } from 'class-variance-authority';

export const COUNTER_VARIANTS = cva(
  'rounded-xs bg-neutral-0 dark:!bg-neutral-10 border border-neutral-4 dark:!border-neutral-9 flex [&_[data-slot=icon]]:rounded-xs [&_[data-slot=icon]]:size-fit [&_[data-slot=label]]:text-neutral-9 [&_[data-slot=label]]:font-medium [&_[data-slot=value]]:text-neutral-10 [&_[data-slot=value]]:font-bold',
  {
    variants: {
      variant: {
        horizontal:
          'max-w-[227px] items-center gap-6 [&_[data-slot=icon]]:min-h-10 [&_[data-slot=icon]]:min-w-10 [&_[data-slot=title]]:items-center [&_[data-slot=title]]:gap-4 [&_[data-slot=label]]:text-body-sm [&_[data-slot=value]]:text-h1 px-4 py-[18px]',
        vertical:
          'max-w-[230px] flex-col gap-1 [&_[data-slot=icon]]:min-h-8 [&_[data-slot=icon]]:min-w-8 [&_[data-slot=title]]:flex-col [&_[data-slot=title]]:gap-2 [&_[data-slot=label]]:text-body [&_[data-slot=value]]:text-display px-4 pt-4 pb-3',
      },
    },
    defaultVariants: {
      variant: 'horizontal',
    },
  },
);
